import React, { useMemo, useState } from "react";
import SimpleModal from "../../SimpleModal";
import {
  ModalActionToolbar,
  ModalBody,
} from "../../PrevailingWageLookup/Shared/tableStyles";
import ReactTooltip from "react-tooltip";
import { ReactTable } from "../ReactTable";
import { normalizeCountyLabel } from "../../../global/utils/countyHelper";

const buildWorksiteArray = (worksites, counties) => {
  if (!worksites) {
    return [];
  }
  return worksites.map((worksite) => {
    // If the county is a string and not a {label, value} object, fix it
    if (
      !!worksite.worksiteCountyTownship &&
      !worksite.worksiteCountyTownship?.label
    ) {
      const state = worksite.worksiteState;
      const stateCounties = counties[state] || [];
      const normalizedSearch = normalizeCountyLabel(
        worksite.worksiteCountyTownship
      );
      const fullCountyInfo = stateCounties.find(
        (county) => normalizeCountyLabel(county.label) === normalizedSearch
      );

      if (fullCountyInfo) {
        return {
          ...worksite,
          worksiteCountyTownship: {
            label: fullCountyInfo.label,
            value: fullCountyInfo.value,
          },
        };
      }
    }
    // Otherwise, return the worksite as-is
    return worksite;
  });
};

const WorksiteLinkingModal = ({
  counties,
  modalOpen,
  toggleModal,
  onSubmit,
  worksites,
  setFieldValue,
  formApi,
}) => {
  const [selectedWorksite, setSelectedWorksite] = useState(null);
  worksites = buildWorksiteArray(worksites, counties);

  const columns = useMemo(
    () => [
      {
        id: "radio",
        accessor: "",
        Cell: ({ row: { original } }) => (
          <>
            <input
              type="radio"
              name="worksiteLinkRadio"
              id={`pwd-${original.rowNum}`}
              className="usa-radio-input"
              tabIndex={0}
              onChange={(e) => e}
              checked={selectedWorksite?.rowNum === original?.rowNum}
              onClick={() => setSelectedWorksite(original)}
            />
            <label
              className="usa-radio-label"
              htmlFor={`pwd-${original.rowNum}`}
              onChange={(e) => e}
              tabIndex={0}
              onClick={() => setSelectedWorksite(original)}
              onKeyUp={(e) => {
                if (e.key === " ") setSelectedWorksite(original);
              }}
              checked={selectedWorksite?.rowNum === original?.rowNum}
            />
          </>
        ),
        disableSortBy: true,
        fixedWidth: 25,
      },
      {
        Header: "City",
        id: "worksiteCity",
        accessor: (d) => d["worksiteCity"],
        Cell: ({ row: { original, index }, column: { id } }) => (
          <>
            <span data-tip data-for={`${id}${index}`}>
              {original.worksiteCity}
            </span>
            <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
              {original.worksiteCity}
            </ReactTooltip>
          </>
        ),
        minWidth: 150,
        maxWidth: 170,
      },
      {
        Header: "State",
        id: "worksiteState",
        accessor: (d) => d["worksiteState"],
        Cell: ({ row: { original, index }, column: { id } }) => (
          <>
            <span data-tip data-for={`${id}${index}`}>
              {original.worksiteState}
            </span>
            <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
              {original.worksiteState}
            </ReactTooltip>
          </>
        ),
        fixedWidth: 150,
      },
      {
        Header: "County",
        id: "worksiteCountyTownship",
        accessor: (d) => d["worksiteCountyTownship"]?.label,
        Cell: ({ row: { original, index }, column: { id } }) => (
          <>
            <span data-tip data-for={`${id}${index}`}>
              {original.worksiteCountyTownship?.label}
            </span>
            <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
              {original.worksiteCountyTownship?.label}
            </ReactTooltip>
          </>
        ),
        minWidth: 200,
        maxWidth: 220,
      },
      {
        Header: "MSA Name / OES Area Title",
        id: "worksiteBlsArea",
        accessor: (d) => d["worksiteBlsArea"],
        Cell: ({ row: { original, index }, column: { id } }) => (
          <>
            <span data-tip data-for={`${id}${index}`}>
              {original.worksiteBlsArea}
            </span>
            <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
              {original.worksiteBlsArea}
            </ReactTooltip>
          </>
        ),
        minWidth: 250,
      },
    ],
    [selectedWorksite]
  );

  return (
    <SimpleModal
      toggleModal={toggleModal}
      modalStatus={modalOpen}
      renderButton={() => null}
      minWidth={"80%"}
      customStyles={{ overflowX: "hidden" }}
    >
      <h3>Select Worksite</h3>
      <ModalBody>
        <p className="pwd-description">
          Select a worksite below from your Prevailing Wage Determination(s),
          which is relevant to the employment described in this application.
        </p>
        <ReactTable
          data={worksites}
          columns={columns}
          pageSizeOptions={[10, 25, 50, 100]}
        />
      </ModalBody>
      <ModalActionToolbar>
        <button
          className="usa-button btn-extra-wide"
          onClick={() =>
            onSubmit(
              counties,
              selectedWorksite,
              setFieldValue,
              toggleModal,
              formApi
            )
          }
        >
          Finish
        </button>
      </ModalActionToolbar>
    </SimpleModal>
  );
};

export default WorksiteLinkingModal;
